import {Title, Text} from '@priority-software/priority-style-react';
import React from 'react';
import styles from '../styles/header.module.scss';
import texts from '../../texts';
import {createDataTestId} from '../../../../../../utils/dataTestId';

type Props = {
    parentTitle: string;
    filesNum: number;
    isLoading: boolean;
    shouldFetchMore: boolean;
    formTitle: string;
};

export const Header = ({parentTitle, filesNum, isLoading, shouldFetchMore, formTitle}: Props) => {
    const generateSubHeaderString = () => {
        const numString = shouldFetchMore ? `${filesNum - 1}+` : filesNum.toString();
        return (texts.number_of_attachments as string)
            .replace('Y', parentTitle)
            .replace('X', numString);
    };

    return (
        <div className={styles.header}>
            <Title
                text={formTitle}
                skin={'h4'}
                textColor="primary-700"
                {...createDataTestId(`attachments-header-title`, true)}
            />
            <Text
                skin={'paragraph-2'}
                textColor="secondary-500"
                {...createDataTestId(`attachments-header-subTitle`, true)}
            >
                {isLoading ? parentTitle : generateSubHeaderString()}
            </Text>
        </div>
    );
};
